// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Vue
import { createApp } from 'vue'
import NewTopicPage from '@components/NewTopicPage.vue'

// Vuetify configuration
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'light',
  },
})

// Mount NewTopicPage to #new-topic-app mount point
function mountNewTopicApp() {
  const el = document.getElementById('new-topic-app')
  if (el && !el.__vue_app__) {
    // Get data attributes passed from Rails
    const formAction = el.dataset.formAction || '/topics'
    const csrfToken = el.dataset.csrfToken || ''
    const userSignedIn = el.dataset.userSignedIn === 'true'
    const forumsEnabled = el.dataset.forumsEnabled === 'true'
    const ticketsEnabled = el.dataset.ticketsEnabled === 'true'
    const teamsEnabled = el.dataset.teamsEnabled === 'true'
    const forums = el.dataset.forums ? JSON.parse(el.dataset.forums) : []
    const teams = el.dataset.teams ? JSON.parse(el.dataset.teams) : []
    const defaultPrivate = el.dataset.defaultPrivate || '0'
    const recaptchaEnabled = el.dataset.recaptchaEnabled === 'true'
    const recaptchaEnterpriseEnabled = el.dataset.recaptchaEnterpriseEnabled === 'true'
    const recaptchaEnterpriseSiteKey = el.dataset.recaptchaEnterpriseSiteKey || ''
    const extensionWhitelist = el.dataset.extensionWhitelist || ''
    const extensionBlacklist = el.dataset.extensionBlacklist || ''
    const docId = el.dataset.docId || ''
    const fromWidget = el.dataset.fromWidget === 'true'
    const translations = el.dataset.translations ? JSON.parse(el.dataset.translations) : {}
    const searchPath = el.dataset.searchPath || '/search.json'
    const pageTitle = el.dataset.pageTitle || 'Open a Ticket'
    const locale = window.location.pathname.split('/')[1] || 'en'
    const resultPath = el.dataset.resultPath || '/' + locale + '/result'
    const knowledgebasePath = el.dataset.knowledgebasePath || '/' + locale + '/knowledgebase'

    const app = createApp(NewTopicPage, {
      formAction,
      csrfToken,
      userSignedIn,
      forumsEnabled,
      ticketsEnabled,
      teamsEnabled,
      forums,
      teams,
      defaultPrivate,
      recaptchaEnabled,
      recaptchaEnterpriseEnabled,
      recaptchaEnterpriseSiteKey,
      extensionWhitelist,
      extensionBlacklist,
      docId,
      fromWidget,
      translations,
      searchPath,
      pageTitle,
      resultPath,
      knowledgebasePath
    })

    app.use(vuetify)
    app.mount('#new-topic-app')
  }
}

// Mount on DOM ready (for initial page load)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountNewTopicApp)
} else {
  mountNewTopicApp()
}

// For Turbolinks support
document.addEventListener('turbolinks:load', mountNewTopicApp)

// Clean up on Turbolinks navigation
document.addEventListener('turbolinks:before-visit', () => {
  const el = document.getElementById('new-topic-app')
  if (el && el.__vue_app__) {
    el.__vue_app__.unmount()
    delete el.__vue_app__
  }
})
